import React from 'react';

export const Vector = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00041 6.58608L1.70741 1.29308C1.5188 1.11092 1.2662 1.01013 1.00401 1.01241C0.741809 1.01469 0.490997 1.11985 0.305589 1.30526C0.120181 1.49067 0.0150115 1.74148 0.0127331 2.00368C0.0104547 2.26588 0.111249 2.51848 0.293408 2.70708L5.58641 8.00008L0.293408 13.2931C0.111249 13.4817 0.0104547 13.7343 0.0127331 13.9965C0.0150115 14.2587 0.120181 14.5095 0.305589 14.6949C0.490997 14.8803 0.741809 14.9855 1.00401 14.9878C1.2662 14.99 1.5188 14.8892 1.70741 14.7071L7.00041 9.41408L12.2934 14.7071C12.482 14.8892 12.7346 14.99 12.9968 14.9878C13.259 14.9855 13.5098 14.8803 13.6952 14.6949C13.8806 14.5095 13.9858 14.2587 13.9881 13.9965C13.9904 13.7343 13.8896 13.4817 13.7074 13.2931L8.41441 8.00008L13.7074 2.70708C13.8029 2.61483 13.8791 2.50449 13.9315 2.38249C13.9839 2.26048 14.0115 2.12926 14.0127 1.99648C14.0138 1.8637 13.9885 1.73202 13.9382 1.60913C13.8879 1.48623 13.8137 1.37458 13.7198 1.28069C13.6259 1.18679 13.5143 1.11254 13.3914 1.06226C13.2685 1.01198 13.1368 0.986677 13.004 0.987831C12.8712 0.988985 12.74 1.01657 12.618 1.06898C12.496 1.12139 12.3857 1.19757 12.2934 1.29308L7.00041 6.58608Z"
      fill={color || '#42526E'}
    />
  </svg>
);
